import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisButton from "../components/controls/jisButton";
import CaseSearch from "../components/core/case_search";
import JisEmptyList from "../components/controls/emptylist";
import Pagenated from "../components/pagenated";

import wordicon from "../assets/ms_word.png";
import excelicon from "../assets/ms_excel.png";
import pdficon from "../assets/pdf.png";
import CustomSearchSortHeader from "../components/core/CustomSearchSortHeader";

function MyCases() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);


   useEffect(() => {
    if (search != null) {
      if (pageIndex >= 0) {
        onSearch(search);
      } else {
        setPageIndex(0);
      }
    }
  }, [pageIndex, pageSize, search]);

  const onSearch = async (sear) => {
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/get-my-cases/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.cases);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/get-my-cases/${pageIndex}/${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onContinue = (caseid) => {
    navigate(`/case-details/${caseid}`);
  };
  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };

  // Add this function after the onDirectSearch function and before the return statement

  // Add this function after the onDirectSearch function and before the return statement

  const onExport = async (doctype) => {
    // Map doctype to MIME and extension
    const typeMap = {
      word: {
        mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ext: "docx",
      },
      excel: {
        mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ext: "xlsx",
      },
      pdf: {
        mime: "application/pdf",
        ext: "pdf",
      },
    };

    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/report/my-case-download/${doctype}`,
        {
          method: "POST",
          body: JSON.stringify(search),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!resp.ok) {
        const data = await resp.json();
        if (data.code === -10) {
          setIsExpired(true);
        } else {
          setErr(data.status || "Export failed");
        }
        setLoading(false);
        return;
      }

      const blob = await resp.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `my-cases.${typeMap[doctype].ext}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl); // Clean up URL

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr("Export failed");
    }
  };
  return (
    <div>
      {/* <CaseSearch onSearch={onDirectSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader
        onSearch={onDirectSearch}
        frequentData={frequentData}
      />
      {cases?.length == 0 && <JisEmptyList />}
      {cases?.length > 0 && (
        <>
          <div className="exportdiv">
            <img
              src={wordicon}
              onClick={() => onExport("word")}
              style={{ cursor: "pointer" }}
            />
            <img
              src={excelicon}
              onClick={() => onExport("excel")}
              style={{ cursor: "pointer" }}
            />
            <img
              src={pdficon}
              onClick={() => onExport("pdf")}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="table">
            <div class="section-cases">
              <span>My Cases </span>
              {/* <span className="total">{count}</span> */}
            </div>
            <div className="table-wrapper">
              <table class="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th className="col-medium">Filing Type</th>
                    <th className="col-medium">Classification</th>
                    <th className="col-medium">Date Initiated</th>
                    <th className="col-medium">Status Level</th>

                    <th className="col-title">Details</th>
                  </tr>
                </thead>
                <tbody>
                  {cases?.map((opt, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${
                            Constants.getItemById(
                              frequentData?.casecategories,
                              opt.caseCategoryId
                            )?.colour
                          }`,
                        }}
                      >
                        {opt.caseNumber ?? opt.referenceNumber}{" "}
                      </td>
                      <td>{opt.caseTitle || "N/A"}</td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casetype,
                          opt.caseTypeId
                        )?.caseType1 || "N/A"}
                      </td>
                      <td>
                        {" "}
                        {Constants.getItemById(
                          frequentData?.casecategories,
                          opt.caseCategoryId
                        )?.categoryTitle || "N/A"}
                      </td>
                      <td>
                        {" "}
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY"
                        ) || "N/A"}
                      </td>
                      <td>
                        {Constants.getItemById(
                          frequentData?.casestatuses,
                          opt.caseStatusId
                        )?.description || "N/A"}
                      </td>
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onContinue(opt.caseId)}
                        >
                          View
                        </JisButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {cases?.length > 0 && (
              <Pagenated
                onChangePageSize={(k) => setPageSize(k)}
                size={pageSize}
                total={count}
                maxPage={20}
                onPick={onPagePick}
              />
            )}
          </div>
        </>
      )}
      <BackLoader open={loading} />
    </div>
  );
}

export default MyCases;
